export const DEFAULT_CUSTOM_GOAL_LABEL = "Custom Goal";

const METRIC_GOALS = {
  orders: "checkouts",
  revenue: "checkouts",
  aov: "checkouts",
  bookings: "bookings",
  custom_goals: "custom",
};

export const METRIC_ORDER = Object.keys(METRIC_GOALS);

const asBoolean = (value, fallback) => {
  if (value === true || value === "true") return true;
  if (value === false || value === "false") return false;
  return fallback;
};

export function reportingGoals(source) {
  const goals = (source && source.reporting_goals) || source || {};
  const label = (goals.customGoalLabel || goals.custom_goal_label || "")
    .toString()
    .trim();

  return {
    checkouts: asBoolean(goals.checkouts, true),
    bookings: asBoolean(goals.bookings, true),
    custom: asBoolean(goals.custom, false),
    customGoalLabel: label || DEFAULT_CUSTOM_GOAL_LABEL,
    checkoutsWebsiteIds:
      goals.checkoutsWebsiteIds || goals.checkouts_website_ids || null,
    bookingsWebsiteIds:
      goals.bookingsWebsiteIds || goals.bookings_website_ids || null,
    customGoalWebsiteIds:
      goals.customGoalWebsiteIds || goals.custom_goal_website_ids || null,
  };
}

export function goalMetrics(source) {
  const goals = reportingGoals(source);
  return METRIC_ORDER.filter((metric) => goals[METRIC_GOALS[metric]]);
}

export default reportingGoals;
